// Copyright (c) 2022 Siemens

/**
 * @module js/DesCatalogImagesViewService
 */

/**
 * Get Filter data
 *
 * @param {Object} props props
 * @return {Object} modified data providerLabel variable
 */
import _ from 'lodash';
import eventBus from 'js/eventBus';
import { publish } from 'js/desCatalogEventBus';
let uidToSkipMap = {};
let contentPathMap = {
    'USE_PROPS_CONTENT_PATH': true
};

export const setProviderLabel = (vmo, props) => {
    const { data, dispatch } = vmo;
    const providerName = props.provider !== 'DES' ? props.provider : 'SIEMENS';
    const viewModelProps = ['dbValue', 'dispValue', 'value', 'uiValue'];
    viewModelProps.forEach((element) => {
        _.set(data, `providerLabel.${element}`, providerName);
    });
    dispatch({ path: 'data', value: { ...data } });
};

export const loadTreeTableData = function (result, nodeBeingExpanded, dataProvider, limit) {
    // filter out the VMOs based on level
    const levelNdx = _.get(nodeBeingExpanded, 'levelNdx', -1);
    const parentUid = _.get(nodeBeingExpanded, 'uid', 'catalogFolder');

    // Initialize tree data, results and new value of skip
    const treeData = _.get(result, 'data.data.treeNavigation.treeData');
    let totalResults = _.get(treeData, 'totalResults', 0);
    let skip = _.get(treeData, 'skip', 0);

    const response = treeData.data[parentUid];
    _.forEach(response, function (treeNode) {

        // for selectionData model this id is important to call update function ref: splmTableselectionHelper.js:383
        treeNode.id = treeNode.uid;
        treeNode.levelNdx = levelNdx + 1;
        treeNode.typeIconURL = treeNode.iconURL;
        if (!nodeBeingExpanded.parentDispName) {
            treeNode.parentDispName = treeNode.displayName;
        } else {
            treeNode.parentDispName = `${nodeBeingExpanded.parentDispName}/${treeNode.displayName}`;
        }
    });

    /*- -*/
    nodeBeingExpanded.cursorObject = {
        startIndex: 0,
        startReached: true,
        endIndex: skip + Number.parseInt(limit),
        endReached: skip >= totalResults
    };

    const vmc = dataProvider.viewModelCollection;
    const loadedVMOs = vmc.getLoadedViewModelObjects();
    let childNodes;
    if (levelNdx === -1) {
        const filteredVMOs = loadedVMOs;
        // Filter out the response VMOs with same UID from loadedVMOs in case there are multiple server calls
        // This is only applicable for root nodes.
        childNodes = _.filter(response, (vmo) => {
            let exists = false;
            _.forEach(filteredVMOs, function (filteredVmo) {
                exists = exists || filteredVmo.uid === vmo.uid;
            });
            return !exists; //we want VMOs that do not exist in loadedVMOs. Hence returning not exists
        });

        childNodes = [...filteredVMOs, ...childNodes];
    } else {
        childNodes = response;
    }

    const lastNode = _.last(childNodes);
    if (!_.isNil(lastNode)) {
        lastNode.incompleteTail = skip < totalResults;
    }

    const treeNodeResult = {
        parentNode: nodeBeingExpanded,
        childNodes,
        totalChildCount: totalResults,
        startChildNdx: 0,
        skip
    };
    _.set(uidToSkipMap, parentUid, skip);

    return treeNodeResult;
};

export const getSkip = (parentNode, vmo, props) => {
    const { data, dispatch } = vmo;
    const id = _.get(parentNode, 'uid');

    if(id === "catalogFolder") {
        data.selectedNodeContentPath = selectedNodeData || props.contentpath || "";
    }
    dispatch({ path: 'data', value: { ...data } });

    return _.get(uidToSkipMap, id, 0);
};

export const autoSelectTreeNodeAsCrumbClicked = (vmo, crumbObj) => {
    const loadedVMOCollection = vmo.dataProviders.navigationTreeProvider.viewModelCollection;
    const loadedVMOs = loadedVMOCollection.getLoadedViewModelObjects();
    let selectedVMO;
    _.forEach(loadedVMOs, function (loadedVMO) {
        if (crumbObj.contentPath === loadedVMO.contentPath) {
            selectedVMO = loadedVMO;
            vmo.dataProviders.navigationTreeProvider.selectionModel.setSelection(loadedVMO);
        } else if (crumbObj.index === 1) {
            vmo.dataProviders.navigationTreeProvider.selectionModel.setSelection(selectedVMO);
            setTimeout(() => {
                eventBus.publish('des-refreshPartsList', { eventData: [{ contentPath: crumbObj.contentPath }] });
            }, 1000);
            crumbObj.index = 0;
        }
    });
}
export const setContentPath = (vmo, selectedCurrentNodeData) => {
    const { data, dispatch } = vmo;
    data.selectedNodeContentPath = selectedCurrentNodeData.contentPath;
    data.isParent = selectedCurrentNodeData.isExpanded;
    data.nodeBeingExpandedName = selectedCurrentNodeData.uid;
    dispatch({ path: 'data', value: { ...data } });
};

export const getContentPath = (treeLoadInput, props) => {
    const { contentpath } = props;
    const defaultPath = treeLoadInput.parentNode.contentPath;
    const useGivenContentPath = _.get(contentPathMap, 'USE_PROPS_CONTENT_PATH');
    // Important note about the flag 'USE_PROPS_CONTENT_PATH':
    // This flag is set to true when the contentPath prop changes (i.e. user selects a different catalog from the dropdown).
    // This flag is reset to false when this function is called and returns the contentpath prop value once.
    // This is done to ensure that the contentpath prop value is used only once to set the contentPath in the view model.
    // After that, the contentPath in the view model is used for subsequent tree loads and expansions.
    if (!useGivenContentPath) {
        return defaultPath || contentpath;
    } else {
        // Flag was true — reset it and proceed with logic
        _.set(contentPathMap, 'USE_PROPS_CONTENT_PATH', false);
        return contentpath || defaultPath;
    }
};

export const executeCleanup = () => {
    _.set(contentPathMap, 'USE_PROPS_CONTENT_PATH', true);
}
export const setContentPathOnUpdate = (vmo, event) => {
    const { data, dataProviders, dispatch } = vmo;
    // check for catalog selection
    if (event.detail.length !== 0) {
        data.selectedNodeContentPath = event.detail.eventData.contentPath;
        data.nodeBeingExpandedName = '';
        uidToSkipMap = {};
        executeCleanup();
        data.filterStatus = event.detail.eventData.filterStatus;
        if (dataProviders) {
            if (dataProviders.navigationTreeProvider.viewModelCollection.loadedVMObjects.length > 0) {
                dataProviders.navigationTreeProvider.viewModelCollection.loadedVMObjects = [];
            }
        }
        dispatch({ path: 'data', value: { ...data } });
        setTimeout(() => {
            eventBus.publish('des-refreshNavigationTable');
        }, 2000);
    }
};

let selectedNodeData;
export const resetSelectedNodeContentPath = (vmo, provider, crumb, props) => {
    uidToSkipMap = {};  // reset the uid to skip map
    executeCleanup();
    const { data, dispatch } = vmo;
    if (crumb && data.selectedNodeContentPath && data.selectedNodeContentPath !=='') {
        selectedNodeData = data.selectedNodeContentPath;
        const nodePath = selectedNodeData.split('::');
        const parts = nodePath[2].split('/');
        if (provider === 'CADENAS') {
            selectedNodeData = `${nodePath[0]}::${nodePath[1]}::${parts[0]}`;
        } else {
            selectedNodeData = `${nodePath[0]}::${nodePath[1]}::`;
        }
        data.selectedNodeContentPath = selectedNodeData
        dispatch({ path: 'data', value: { ...data } });
    }
    if (props.filterunit && props.filterunit !== "") {
        data.selectedNodeContentPath = props.filterunit
        dispatch({ path: 'data.selectedNodeContentPath', value: data.selectedNodeContentPath });
    }
};

const createColumnInfo = function (displayName, width) {
    return {
        name: '',
        displayName: _.escape(displayName),
        isTreeNavigation: true,
        maxWidth: (width + 700),
        minWidth: 250,
        width: width
    };
}

function adjustTableWidth(tableId) {
    const childElement = (document.getElementById(tableId) || document.querySelectorAll('des-catalog-navigation')[0]);
    let tablewidth = 275;
    if (_.isNil(childElement)) {
        return tablewidth;
    }
    else {
        const parentDiv = childElement.parentNode;
        const parentWidthValue = parseFloat(window.getComputedStyle(parentDiv).getPropertyValue('width'));
        tablewidth = (parentWidthValue - 50);
        childElement.style.width = tablewidth;
        return tablewidth;
    }
}

export const loadTreeMatrixColumns = (vmo, dataProvider) => {
    const { data, dispatch } = vmo;
    const columns = [];
    const columnOfNavigation = createColumnInfo(data.tableheader, adjustTableWidth(data.tableId));

    columns.push(columnOfNavigation);

    dataProvider.columnConfig = {
        columns: columns
    };
    dispatch({ path: 'data', value: { ...data } });
    return columns;
}

export const resetContentPathOnUpdateOfProps = (vmo, props) => {
    const { data, dataProviders, dispatch } = vmo;
    if (props.contentpath) {
        _.set(data, 'selectedNodeContentPath', props.contentpath);
    } else {
        _.set(data, 'selectedNodeContentPath', "");
    }
    _.set(data, 'nodeBeingExpandedName', '');
    uidToSkipMap = {};
    const loadedVMObjectsLength = _.get(dataProviders, 'navigationTreeProvider.viewModelCollection.loadedVMObjects');
    if (dataProviders && loadedVMObjectsLength.length > 0) {
        _.set(dataProviders, 'navigationTreeProvider.viewModelCollection.loadedVMObjects', []);
    }
    dispatch({ path: 'data', value: { ...data } });
    eventBus.publish('des-refreshNavigationTable');
}

export const conditionalCacheHandling = (props) => {
    if (props.expansionstate === 'no-cache') {
        let treeState;
        let treeStateVal;
        Object.keys(localStorage).forEach(key => {
            if (key.includes("awTreeTableState")) {
                treeState = localStorage.getItem(key);
                if (treeState && treeState.length > 0) {
                    treeStateVal = JSON.parse(treeState);
                    treeStateVal.DesCatalogNavigation = {};
                    localStorage.setItem(key, JSON.stringify(treeStateVal));
                }
            }
        });
    } else {
        console.log('Persist cache for tree navigation view');
    }
}

export const customSelectionChangeHandler = (localSelectionData) => {
    if (!_.isEmpty(localSelectionData.selected)) {
        publish('des-catalog-navigation.selectionChange', localSelectionData.selected);
        console.log('in customselection handler selection',localSelectionData.selected);
    }else{
        console.log('in customselection handler deselection',localSelectionData.selected);
        publish('des-catalog-navigation.deselectionChange');
    }
};
